import React from "react";
import useFilterableIndex from "../../hooks/useFilterableIndex";

export const BalanceLogContext = React.createContext([]);

const UnnamedComponent = (props) => {
  const {
    clearable,
    currentPage,
    dateFilterState,
    datePickerParams,
    fetchData,
    fetchable,
    fetching,
    filterCount,
    handleApplyFilter,
    handleClearFilter,
    handlePageChange,
    inputParams,
    perpage,
    resources,
    resourcesMeta,
  } = useFilterableIndex("/api/v1/users/affiliators/balance_logs");

  const contextValue = React.useMemo(
    () => ({
      clearable,
      currentPage,
      dateFilterState,
      datePickerParams,
      fetchData,
      fetchable,
      fetching,
      filterCount,
      handleApplyFilter,
      handleClearFilter,
      handlePageChange,
      inputParams,
      perpage,
      resources,
      resourcesMeta,
    }),
    [
      clearable,
      currentPage,
      dateFilterState,
      datePickerParams,
      fetchData,
      fetchable,
      fetching,
      filterCount,
      handleApplyFilter,
      handleClearFilter,
      handlePageChange,
      inputParams,
      perpage,
      resources,
      resourcesMeta,
    ],
  );
  return (
    <BalanceLogContext value={contextValue}>{props.children}</BalanceLogContext>
  );
};
export default UnnamedComponent;
